import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from 'widget/components';

const Typing = () => {
  const { t } = useTranslation();

  return (
    <Text className="whatcrm-widget-typing" color="navy">{t`typing`}</Text>
  );
};

export default Typing;
